var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTitleLeftIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4401_1956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4882 42.8371L22.6805 35.0378L25.4882 27.296L36.9903 23.9808L48.4924 27.296L51.3001 35.0378L48.4924 42.8371L36.9903 46.1906L25.4882 42.8371ZM27.1922 35.0378L29.2061 39.1578L37.0097 41.2466L44.8714 39.1578L46.8271 35.0378L44.8714 31.0136L37.0097 28.9249L29.2061 31.0136L27.2116 35.0378H27.1922Z",
    fill: "#C1CECB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.971 38.3338L39.3333 37.3757L40.3015 35.0761L39.3527 32.7958L37.0291 31.8376L34.6667 32.8149L33.6985 35.1145L34.6667 37.3949L36.971 38.3338Z",
    fill: "#C1CECB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1466 59.8346L37.0097 62L47.8534 59.8346L58 53.7983L55.7151 49.8507L46.8658 54.2199L37.0097 55.7146L27.1342 54.2199L18.2849 49.8507L16 53.7983L26.1466 59.8346Z",
    fill: "#C1CECB"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleLeftIcon);
export default __webpack_public_path__ + "static/media/title-left-icon.f82cfe35a637d7a38e57ce6010b97bf1.svg";
export { ForwardRef as ReactComponent };